/* ============================================================
   CURATED COLLECTION FILTERS — v82
   See snippets/collection-filters.liquid for why this is done in
   the page rather than through Shopify's facet URLs.

   Rules:
     within a group  -> OR   (Cat-eye or Oval)
     across groups   -> AND  (Cat-eye AND black AND polarised)
   Counts on each option are "how many frames would I get if I
   picked this", i.e. every OTHER group's choices applied first.
   ============================================================ */
(function () {
  'use strict';

  var panel = document.getElementById('tbtFilters');
  var grid  = document.querySelector('[data-tbt-grid]');
  if (!panel || !grid) return;

  var optEls   = [].slice.call(panel.querySelectorAll('[data-tbt-opt]'));
  var chipWrap = document.querySelector('[data-tbt-chips]');
  var badge    = document.querySelector('[data-tbt-badge]');
  var showing  = document.querySelector('[data-tbt-showing]');
  var showingN = document.querySelector('[data-tbt-showing-n]');
  var empty    = document.querySelector('[data-tbt-empty]');
  var hiddenIn = document.querySelector('[data-tbt-hidden]');

  /* ---- the catalogue, read once off the rendered cards ---- */
  var cards = [].slice.call(grid.querySelectorAll('.card')).map(function (el) {
    return {
      el: el,
      tags: (el.getAttribute('data-tags') || '').split(' ').filter(Boolean),
      price: parseFloat(el.getAttribute('data-price') || '0')
    };
  });
  if (!cards.length) return;

  /* ---- options, indexed by group ---- */
  var groups = {};
  optEls.forEach(function (el) {
    var g = el.getAttribute('data-group');
    (groups[g] = groups[g] || []).push({
      el: el,
      group: g,
      value: el.getAttribute('data-value'),
      label: el.getAttribute('data-label'),
      tags: (el.getAttribute('data-tags') || '').split(' ').filter(Boolean),
      min: el.hasAttribute('data-min') ? parseFloat(el.getAttribute('data-min')) : null,
      max: el.hasAttribute('data-max') ? parseFloat(el.getAttribute('data-max')) : null,
      on: false
    });
  });
  var groupKeys = Object.keys(groups);

  function optMatch(card, o) {
    if (o.min !== null || o.max !== null) {
      if (o.min !== null && card.price < o.min) return false;
      if (o.max !== null && card.price > o.max) return false;
      return true;
    }
    for (var i = 0; i < o.tags.length; i++) {
      if (card.tags.indexOf(o.tags[i]) > -1) return true;
    }
    return false;
  }

  function groupMatch(card, key) {
    var chosen = groups[key].filter(function (o) { return o.on; });
    if (!chosen.length) return true;
    for (var i = 0; i < chosen.length; i++) {
      if (optMatch(card, chosen[i])) return true;
    }
    return false;
  }

  function matchesAll(card, skipKey, override) {
    for (var i = 0; i < groupKeys.length; i++) {
      var k = groupKeys[i];
      if (k === skipKey) {
        if (override && !optMatch(card, override)) return false;
        continue;
      }
      if (!groupMatch(card, k)) return false;
    }
    return true;
  }

  function activeOpts() {
    var out = [];
    groupKeys.forEach(function (k) {
      groups[k].forEach(function (o) { if (o.on) out.push(o); });
    });
    return out;
  }

  /* ---- render ---- */
  function apply(pushUrl) {
    var shown = 0;

    cards.forEach(function (c) {
      var ok = matchesAll(c, null, null);
      c.el.hidden = !ok;
      if (ok) shown++;
    });

    groupKeys.forEach(function (k) {
      groups[k].forEach(function (o) {
        var n = 0;
        for (var i = 0; i < cards.length; i++) {
          if (matchesAll(cards[i], k, o)) n++;
        }
        var nEl = o.el.querySelector('.tbt-opt-n');
        if (nEl) nEl.textContent = n;
        o.el.setAttribute('aria-pressed', o.on ? 'true' : 'false');
        o.el.classList.toggle('is-on', o.on);
        var dead = (n === 0 && !o.on);
        o.el.classList.toggle('is-dead', dead);
        o.el.disabled = dead;
      });
    });

    var active = activeOpts();

    if (chipWrap) {
      chipWrap.innerHTML = '';
      if (active.length) {
        active.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'tbt-chip';
          b.innerHTML = '<span></span><i aria-hidden="true">&times;</i>';
          b.firstChild.textContent = o.label;
          b.setAttribute('aria-label', 'Remove filter ' + o.label);
          b.addEventListener('click', function () { o.on = false; apply(true); });
          chipWrap.appendChild(b);
        });
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'tbt-chip-clear';
        clear.textContent = 'Clear all';
        clear.addEventListener('click', clearAll);
        chipWrap.appendChild(clear);
        chipWrap.hidden = false;
      } else {
        chipWrap.hidden = true;
      }
    }

    if (badge) {
      badge.textContent = active.length;
      badge.hidden = active.length === 0;
    }

    var word = shown === 1 ? 'frame' : 'frames';
    if (showing) {
      showing.textContent = active.length
        ? shown + ' of ' + cards.length + ' ' + word
        : cards.length + ' ' + word;
    }
    if (showingN) showingN.textContent = shown;

    if (empty) empty.hidden = shown !== 0;
    grid.hidden = shown === 0;

    syncSortForm(active);
    if (pushUrl) writeUrl(active);
  }

  function clearAll() {
    groupKeys.forEach(function (k) {
      groups[k].forEach(function (o) { o.on = false; });
    });
    apply(true);
  }

  /* ---- url: shareable, and survives the sort reload ---- */
  function params(active) {
    var by = {};
    active.forEach(function (o) { (by[o.group] = by[o.group] || []).push(o.value); });
    return by;
  }

  function writeUrl(active) {
    if (!window.history || !history.replaceState || !window.URLSearchParams) return;
    var by = params(active);
    var q = new URLSearchParams(window.location.search);
    groupKeys.forEach(function (k) { q.delete(k); });
    Object.keys(by).forEach(function (k) { q.set(k, by[k].join(',')); });
    var s = q.toString();
    history.replaceState(null, '', window.location.pathname + (s ? '?' + s : ''));
  }

  /* Sorting reloads the page through a plain GET form. Without these the
     shopper's filters would be thrown away every time they changed the sort. */
  function syncSortForm(active) {
    if (!hiddenIn) return;
    hiddenIn.innerHTML = '';
    var by = params(active);
    Object.keys(by).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = k;
      i.value = by[k].join(',');
      hiddenIn.appendChild(i);
    });
  }

  function readUrl() {
    if (!window.URLSearchParams) return;
    var q = new URLSearchParams(window.location.search);
    groupKeys.forEach(function (k) {
      var raw = q.get(k);
      if (!raw) return;
      var wanted = raw.split(',');
      groups[k].forEach(function (o) {
        if (wanted.indexOf(o.value) > -1) o.on = true;
      });
    });
  }

  /* ---- events ---- */
  optEls.forEach(function (el) {
    el.addEventListener('click', function () {
      var g = el.getAttribute('data-group');
      var v = el.getAttribute('data-value');
      groups[g].forEach(function (o) { if (o.value === v) o.on = !o.on; });
      apply(true);
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tbt-open]')) {
      e.preventDefault();
      document.body.classList.add('tbt-locked');
      panel.classList.add('is-open');
    } else if (e.target.closest('[data-tbt-clear]')) {
      e.preventDefault();
      clearAll();
    } else if (e.target.closest('[data-tbt-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function close() {
    document.body.classList.remove('tbt-locked');
    panel.classList.remove('is-open');
  }

  /* A scroll lock that outlives its panel makes the whole site unscrollable.
     Never let one survive an error or a page transition. */
  window.addEventListener('pagehide', close);
  window.addEventListener('error', close);

  readUrl();
  apply(false);
})();